import { render } from "./TourBase.vue?vue&type=template&id=fd947858&scoped=true&ts=true"
import script from "./TourBase.vue?vue&type=script&lang=ts"
export * from "./TourBase.vue?vue&type=script&lang=ts"

import "./TourBase.vue?vue&type=style&index=0&id=fd947858&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd947858"]])

export default __exports__